import React from 'react'
import ClassNames from 'classnames'
import { RiskBoxStyle } from './styled'
import ReactTooltip from 'react-tooltip'

/**
 * Riskbox description
 * - ...
 */

export class RiskBox extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    const {
      className,
      score,
      title,
      disabled,
      isDisable,
      useTooltip,
      tootipValue,
      useTootipFor,
      key,
      style,
      value,
    } = this.props

    const riskBoxColor = () => {
      if (parseFloat(value) >= 4.5) {
        return 'red'
      } else if (parseFloat(value) >= 3.5) {
        return 'orange'
      } else if (parseFloat(value) >= 2.5) {
        return 'light-orange'
      } else if (parseFloat(value) >= 1.5) {
        return 'light-green'
      } else if (parseFloat(value) >= 0) {
        return 'green'
      } else {
        return 'gray'
      }
    }

    const riskColor = riskBoxColor()
    return (
      <RiskBoxStyle
        className={ClassNames('risk-box', riskColor, className)}
        style={style}
        value={value ? value : 0}
        disabled={disabled || isDisable}
        data-tip={tootipValue}
        data-for={useTootipFor}
        data-border={true}
        data-class="tooltip"
        data-background-color="#595959"
        data-arrow-color="#595959"
      >
        <div className="score">{score ? score : 'N/A'}</div>
        <div className="title">{title}</div>
        {useTooltip && (
          <ReactTooltip id={useTootipFor} place="bottom" effect="solid">
            {/* {tootipHtmlValue} */}
          </ReactTooltip>
        )}
      </RiskBoxStyle>
    )
  }
}
